import axios from 'axios'

const fetchDeleteDevelopmentPlanById = async (developmentPlanId: number) => {
  const response = await axios
    .delete(`/development_plan/${developmentPlanId}`)
    .then((res) => res.data)
    .catch((error) => {
      return { ok: false, message: error.message }
    })

  return response
}

export default fetchDeleteDevelopmentPlanById
